import { proxy } from "@/util/proxy.mjs";

type FooterRefs = {
  Logo: (() => JSX.Element) | null;
  Social:
    | {
        href: string;
        label: string;
        target: string;
      }[]
    | null;
  Company:
    | {
        href: string;
        label: string;
        target: string;
      }[]
    | null;
};

const refs = proxy<FooterRefs>({
  Logo: null,
  Social: null,
  Company: null,
});

export default refs;
